import React from 'react';
import { useLoader } from '../../../hooks/LoaderContext';
import './Loader.css';

export const Loader = () => {
    const { loading } = useLoader(); 

    return (
        loading ? (
            <div className="loader-overlay">
                <div className="loader"></div>
            </div>
        ) : null
    );
};
